import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateContractObjectGql } from '../../workOrderQueries';

const requestId = 'uerUpdateContractObject';

export const useUerUpdateContractObject = (contractId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();
    const [reset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        reset(undefined);
        onSuccess?.();
    }, [onSuccess, reset]);

    const [, status, , request] = useRequest({
        requestId,
        query: uerUpdateContractObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const makeRequest = useCallback(
        (input: ContractObjectUpdateInput) => {
            dispatch(request({ contractId, input }));
        },
        [contractId, dispatch, request],
    );

    useEffect(() => {
        reset(undefined);
    }, [reset]);

    return { status, makeRequest };
};
